import React from 'react';
import { AlertOctagon } from 'lucide-react';
import WhatsPROLogo from '../../assets/logos/WhatsPRO.svg';

// UI kit
import { Card, Button } from '@/components/ui';

const ErrorScreen = () => {

    const query = new URLSearchParams(window.location.search);
    const error = query.get('error');

    return (
        <div className="flex min-h-screen w-full items-center justify-center bg-background px-4">
            <Card className="w-full max-w-md overflow-hidden p-0 text-center">
                {/* deck accent bar — thin brand gradient, used sparingly */}
                <div className="h-1 w-full bg-grad" />
                <div className="flex flex-col items-center gap-5 px-8 py-12">
                    <div className="flex h-14 w-14 items-center justify-center rounded-full bg-danger-tint text-danger">
                        <AlertOctagon className="h-7 w-7" />
                    </div>
                    <img src={WhatsPROLogo} alt="WhatsPRO" className="h-7 w-auto" />
                    <h1 className="text-xl font-bold tracking-[-0.01em] text-foreground">
                        Algo salió mal
                    </h1>
                    <p className="max-w-sm text-sm text-muted-foreground text-balance">
                        {error ?? 'Ocurrió un error inesperado. Por favor, intentalo de nuevo'}
                    </p>
                    <Button
                        className="w-full"
                        onClick={() => {
                            window.location.href = 'https://flowypartners.com/whatspro';
                        }}
                    >
                        Volver
                    </Button>
                </div>
            </Card>
        </div>
    );
};

export { ErrorScreen };
